var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "var(--secondaryText)",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8412 1.66666H10.3412C7.77192 1.66666 6.56697 2.5784 6.31594 4.7825C6.26342 5.24361 6.64531 5.62499 7.10941 5.62499H8.84115C12.3412 5.62499 13.9662 7.24999 13.9662 10.75V12.4817C13.9662 12.9458 14.3475 13.3277 14.8086 13.2752C17.0127 13.0242 17.9245 11.8192 17.9245 9.24999V5.74999C17.9245 2.83332 16.7578 1.66666 13.8412 1.66666Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9245 10.75V14.25C12.9245 17.1667 11.7578 18.3333 8.84115 18.3333H5.34115C2.42448 18.3333 1.25781 17.1667 1.25781 14.25V10.75C1.25781 7.83332 2.42448 6.66666 5.34115 6.66666H8.84115C11.7578 6.66666 12.9245 7.83332 12.9245 10.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyFill);
export default __webpack_public_path__ + "static/media/Copy-fill.b36604f9a6eddc8c32738ae766cd603f.svg";
export { ForwardRef as ReactComponent };